import { StyleSheet } from "react-native";
import { formScreen } from "../Styles/formScreen";
import { mainScreen } from "../Styles/mainScreen";


export default StyleSheet.create({
  ...mainScreen,
  container: {
    flex: 1,
    paddingHorizontal: 10,
    backgroundColor: "#aa0000",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  iconEdit: {
    position: "absolute",
    // : 0,
    top: 5,
    right: 0,
  },
  dataProperty: {
    fontFamily: "Montserrat-Medium",
    fontSize: 14,
    color: "#F1F1F1",
  },

  dataValue: {
    fontFamily: "Montserrat",
    marginTop: 2,
    fontSize: 15,
    color: "#C1C1C1",

  },
  alert: {
    margin: 24,
    color: "#FFF",
    textAlign: "center",
  },
  iconToggle: {
    paddingLeft: 10,
  },
  iconBarRight: {
    paddingRight: 10,
  },
  textHeader: {
    color: "#000",
    fontSize: 20,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
  },
  input: {
    marginTop: 10,
    padding: 10,
    width: 300,
    backgroundColor: "#fff",
    fontSize: 16,
    borderRadius: 10,
  },
  botao: {
    width: 300,
    height: 42,
    backgroundColor: "#ff0000",
    marginTop: 20,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },

  botaoAdicionar: {
    height: 42,
    marginTop: 20,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    borderColor: "#00F000",
    borderWidth: 2,
  },
  botaoTextAdicionar: {
    fontFamily: "Montserrat-Medium",
    fontSize: 16,
    color: "#0F0",
  },

  botaoText: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#fff",
  },
  iconTrash: {
    justifyContent: "center",
  },
  containerFone: { flex: 1, flexDirection: "row" },
});
